import Tooltip from "@mui/material/Tooltip";
import { motion } from "framer-motion";
import { useMemo } from "react";
import Icon, { IconNames } from "../../core/components/Icon.tsx";
import "./Button.css";

type ButtonProps = {
    onClick?: () => void;
    disabled?: boolean;
    loading?: boolean;
    label?: string;
    type?: "button" | "submit" | "reset";
    disabledTooltip?: string;
    fullWidth?: boolean;
    backgroundColor?: string;
    icon?: IconNames;
    iconTheme?: "light" | "dark" | "grey" | "green";
    hoverBackgroundColor?: string;
};

function Button({
    onClick,
    disabled,
    loading = false,
    label = "Cadastrar",
    type = "button",
    disabledTooltip,
    fullWidth = false,
    backgroundColor = "#0946B8",
    icon,
    iconTheme = "light",
    hoverBackgroundColor = "#003393",
}: ButtonProps) {

    const isDisabled = useMemo(() => disabled || loading, [disabled, loading]);
    const tooltip = useMemo(() => {
        return isDisabled ? disabledTooltip : undefined;
    }, [isDisabled, disabledTooltip]);

    return (
        <Tooltip title={tooltip} disableInteractive>
            <span className="button-wrapper" style={{
                width: fullWidth ? "100%" : "fit-content",
            }}>
                <motion.button
                    initial={{ opacity: 0, scale: 0.98 }}
                    animate={{ opacity: 1, scale: 1 }}
                    whileHover={{ scale: isDisabled ? 1 : 1.04, backgroundColor: disabled ? undefined : hoverBackgroundColor && hoverBackgroundColor }}
                    whileTap={{ scale: isDisabled ? 1 : 0.96 }}
                    transition={{ duration: 0.15 }}
                    className="button-container"
                    onClick={onClick}
                    type={type}
                    disabled={isDisabled}
                    aria-disabled={isDisabled}
                    style={{
                        backgroundColor: backgroundColor,
                    }}
                >
                    {icon ? (
                        <Icon name={icon} size="lg" theme={iconTheme} />
                    ) : (
                        <span style={{ width: 16 }} />
                    )}
                    <motion.span
                        key="Label"
                        className="button-label"
                        initial={{ opacity: 0, y: 4 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -4 }}
                        transition={{ duration: 0.15 }}
                    >
                        {label}
                    </motion.span>
                    <motion.span
                        className="button-spinner"
                        aria-hidden
                        animate={{ opacity: loading ? 1 : 0 }}
                        style={{ width: 16, visibility: loading ? "visible" : "hidden" }}
                        transition={{ duration: 0.18 }}
                    />
                </motion.button>
            </span>
        </Tooltip>
    );
}

export default Button;